import commonConstant from './_commonConstant';

import {
  addClassNameByTagName,
  removeClassNameTagName,
  createCookie,
  getCookie,
  deleteCookie,
  paymentKioskParkingGateLocation,
} from '../helpers';

// cookie
const createCookieToken = (token, expires) => createCookie(commonConstant.cookieToken, token, expires);
const getCookieToken = () => getCookie(commonConstant.cookieToken);
const deleteCookieToken = () => deleteCookie(commonConstant.cookieToken);
const createCookieUserId = (id, expires) => createCookie(commonConstant.cookieUserId, id, expires);
const getCookieUserId = () => getCookie(commonConstant.cookieUserId);
const deleteCookieUserId = () => deleteCookie(commonConstant.cookieUserId);
const createCookieExpires = (id, expires) => createCookie(commonConstant.cookieExpires, id, expires);
const getCookieExpires = () => getCookie(commonConstant.cookieExpires);
const deleteCookieExpires = () => deleteCookie(commonConstant.cookieExpires);

// add remove class body
const addClassBGBlack = () => addClassNameByTagName('body', commonConstant.addClassNameBGBlack);
const removeClassBGBlack = () => removeClassNameTagName('body', commonConstant.removeClassNameBG);

// function calculate time park
const timePark = parkingTimeParked => {
  try {
    if (parkingTimeParked || parkingTimeParked === 0) {
      return parkingTimeParked * 60 * 1000;
    }
    return null;
  } catch (error) {
    return null;
  }
};

// check time to refresh token
const checkTimeToRefreshToken = () => {
  try {
    if (new Date() >= new Date(new Date(getCookieExpires())).setMinutes(new Date(getCookieExpires()).getMinutes() - 5) && new Date() < new Date(getCookieExpires())) {
      return true;
    }
  } catch (error) {
    return false;
  }
};

// map content
const mapContentPaymentMethod = (data, obj) => {
  try {
    switch (data.paymentMethod) {
      case commonConstant.paymentMethodCash:
        return 'Cash';
      case commonConstant.paymentMethodCreditCard:
        return 'Credit Card';
      case commonConstant.paymentMethodPPMobile:
        return obj.isSuperAdmin ? 'Promptpay Mobile' : 'EZY Payment';
      case commonConstant.paymentMethodPPKiosk:
        return obj.isSuperAdmin ? `Promptpay Kiosk - ${data.paymentLocation}` : 'EZY Payment';
      case commonConstant.paymentMethodPPKioskParkingGate:
        return obj.isSuperAdmin ? `Promptpay Kiosk parking gate - ${paymentKioskParkingGateLocation(data.paymentLocation)}` : 'EZY Payment';
      case commonConstant.paymentMethodPPTablet:
        return obj.isSuperAdmin ? 'Promptpay Tablet' : 'EZY Payment';
      case commonConstant.paymentMethodLinePay:
        return 'Line Pay';
      default:
        return null;
    }
  } catch (error) {
    return null;
  }
};

// regex
const trimSpace = text => {
  try {
    return text ? text.replace(/ /g, '') : '';
  } catch (error) {
    return null;
  }
};
const trimColon = text => {
  try {
    return text ? text.replace(/:/g, '') : '';
  } catch (error) {
    return null;
  }
};

const randomNumber = () => (window.crypto || window.msCrypto).getRandomValues(new Uint32Array(1));

export {
  // class body
  addClassBGBlack,
  removeClassBGBlack,
  // cookie
  createCookieToken,
  getCookieToken,
  deleteCookieToken,
  createCookieUserId,
  getCookieUserId,
  deleteCookieUserId,
  createCookieExpires,
  deleteCookieExpires,
  // timepark
  timePark,
  // check time to refresh token
  checkTimeToRefreshToken,
  // map content
  mapContentPaymentMethod,
  // regex
  trimSpace,
  trimColon,
  // random
  randomNumber,
};
